import { tv } from 'tailwind-variants';

export const progressBarRecipe = tv({
  slots: {
    root: 'relative mt-1 transition-all duration-300 ease-out overflow-hidden',
    progress:
      'absolute left-0 top-0 h-full transition-all duration-300 ease-out',
  },
  variants: {
    variant: {
      highlight: {
        root: ['bg-brand-surface-info-active'],
        progress: ['bg-brand-fill-brand'],
      },
      primary: {
        root: ['bg-brand-surface-info-active'],
        progress: ['bg-brand-fill-brand'],
      },
      success: {
        root: ['bg-brand-surface-success-active'],
        progress: ['bg-brand-fill-success'],
      },
      critical: {
        root: ['bg-brand-surface-critical-active'],
        progress: ['bg-brand-fill-critical'],
      },
      magic: {
        root: ['bg-brand-surface-magic-active'],
        progress: ['bg-brand-fill-magic'],
      },
    },
    size: {
      sm: {
        root: 'h-2 rounded-[4px]',
        progress: 'rounded-[4px]',
      },
      md: {
        root: 'h-4',
        progress: 'rounded-[4px]',
      },
      lg: {
        root: 'h-8',
        progress: 'rounded-[4px]',
      },
    },
  },
  defaultVariants: {
    variant: 'highlight',
    size: 'md',
  },
});
